module.exports = __webpack_public_path__ + "img/home-logo.aff0fff5.png";